// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iNUyc","right":"styles_right__2Kv5S"};